import React from 'react';

interface ContainerProps {
	children: React.ReactNode;
}
export const ContainerInputs: React.FC<ContainerProps> = ({ children }) => (
	<div className="flex w-full flex-col md:flex-row items-baseline gap-4">
		{children}
	</div>
);
